import { Base, Response } from '@.api/methods';
import { Request } from '@/Types';

import { CreateParentCompanyRequest, UpdateParentCompanyRequest } from './Request';
import { CreateParentCompanyResponse, GetParentCompanyResponse, ListParentCompaniesResponse, UpdateParentCompanyResponse } from './Responses';

export class ParentCompanyApi extends Base {
    public list(query?: Request.All) {
        this.setPath('parent-companies');

        if (query) {
            /**
             * @todo need we need a comprehensive solution
             */
            const _query = {
                ...query,
                q: query?.search,
                search: undefined,
                sort_by: query?.sort === 'desc' ? `-${query?.order_by}` : query?.order_by,
            };

            this.setQuery(_query);
        }

        return this.getRequest() as Response<ListParentCompaniesResponse>;
    }

    public create(data: CreateParentCompanyRequest) {
        this.setPath('parent-companies');

        this.setData(data);

        return this.postRequest() as Response<CreateParentCompanyResponse>;
    }

    public update(parentCompanyId: number, data: UpdateParentCompanyRequest) {
        this.setPath(`parent-companies/${parentCompanyId}`);

        this.setData(data);

        return this.putRequest() as Response<UpdateParentCompanyResponse>;
    }

    public destroy(parentCompanyId: number) {
        this.setPath(`parent-companies/${parentCompanyId}`);

        return this.deleteRequest() as Response;
    }

    public getById(parentCompanyId: number) {
        this.setPath(`parent-companies/${parentCompanyId}`);

        return this.getRequest() as Response<GetParentCompanyResponse>;
    }
}
